import {Fragment} from 'react'
import {useRouteLoaderData} from '@remix-run/react'
import type {Product, RootLoaderResponse} from '~/types'
import {getDomainConfig} from '~/domains'
import {cssDomains} from '~/utils/constants'
import {ProductCard} from './category-product-card'
import {ProductCardSpecsLayout} from './category-product-card-specs-layout'
import {ProductEUCard} from './category-product-eu-card-layout'

const specsCardDomains = ['expertstopchoice', 'expertstopchoices', 'bestexpertschoice']

const CategoryProducts = ({
  from,
  to,
  products,
  showProductPageLinks = true,
}: {
  from?: number
  to?: number
  products: Product[]
  showProductPageLinks?: boolean
}) => {
  const {isUSLocale, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const {domainName, domainType} = getDomainConfig(domain, locale)

  const showSpecsCard = domainType === 'insider' || (isUSLocale && specsCardDomains.includes(domainName))
  const showEUcard = domainType === 'eu'
  const isMagaDomainType = domainType === 'maga'

  const showListingsCta =
    cssDomains.includes(domainName) &&
    products?.some(
      (product) => product?.storeListings && (product?.storeListings?.amazon || product?.storeListings?.ebay),
    )

  const renderCard = (index: number, product: Product) => {
    switch (true) {
      case isMagaDomainType || showEUcard:
        return <ProductEUCard index={index} product={product} />
      case showSpecsCard:
        return <ProductCardSpecsLayout index={index} product={product} showProductPageLinks={showProductPageLinks} />
      default:
        return (
          <ProductCard
            index={index}
            product={product}
            showListingsCta={showListingsCta}
            showProductPageLinks={showProductPageLinks}
          />
        )
    }
  }
  return products?.slice(from, to)?.map((product, i) => {
    const index = i + (from ?? 0)
    return <Fragment key={`${product.asin}-${index}`}>{renderCard(index, product)}</Fragment>
  })
}

export default CategoryProducts
